import mutationTypes from './mutationTypes';

export default {
  setConfig({ commit }, config) {
    commit(mutationTypes.SET_CONFIG, config);
  },
  removeBet({ commit, getters, dispatch }, bet) {
    commit(mutationTypes.REMOVE_BET, bet);
    if (getters.ticket.bets.length) {
      dispatch('setBetMinPayment');
      dispatch('splitPaymentPerBet');
      dispatch('checkBalance');
    }

    if (!getters.ticket.bets.length) {
      dispatch('emptyBetslip');
    }
  },
  addDataToBetslip({ commit, dispatch }, data) {
    commit(mutationTypes.ADD_BET, data);
    dispatch('setFutureBets');
    dispatch('allowRequest', false);
    dispatch('resetSelectedBet');
    dispatch('splitPaymentPerBet');
  },
  addRebetToBetslip({ commit, dispatch }, data) {
    commit(mutationTypes.ADD_BET, data);
    dispatch('allowRequest', false);
    dispatch('resetSelectedBet');
    dispatch('splitPaymentPerBet');
  },
  emptyBetslip({ commit, dispatch }) {
    commit(mutationTypes.EMPTY_BETSLIP);
    dispatch('resetSelectedBet');
    dispatch('togglePayinAction', false);
  },
  setBetMinPayment({ commit }) {
    commit(mutationTypes.SET_BET_MIN_PAYMENT);
  },
  setTotalPayment({ commit, dispatch, getters }, value) {
    commit(mutationTypes.SET_TOTAL_PAYMENT, value);
    dispatch('setBetMinPayment');
    dispatch('checkBalance');
    dispatch('splitPaymentPerBet');
  },
  splitPaymentPerBet({ commit }) {
    commit(mutationTypes.SPLIT_PAYMENT_PER_BET);
  },
  setTotalStake({ commit, dispatch }, stake) {
    commit(mutationTypes.SET_TOTAL_STAKE, stake);
    dispatch('checkBalance');

    commit(mutationTypes.SET_TOTAL_PAYMENT, stake);
    dispatch('splitPaymentPerBet');
  },
  updateTicketRoundInfo({ commit }) {
    commit(mutationTypes.UPDATE_TICKET_ROUND_INFO);
  },
  setFutureBets({ commit, dispatch }, futureBets) {
    commit(mutationTypes.SET_FUTURE_BETS, futureBets);
    dispatch('updateTicketRoundInfo');

    dispatch('setBetMinPayment');
    if (futureBets) dispatch('splitPaymentPerBet');

    dispatch('resetSelectedBet');
    dispatch('checkBalance');
  },
  showHideBetslip({ commit }) {
    commit(mutationTypes.SHOW_HIDE_BETSLIP);
  },
  togglePayinAction({ commit }, payin) {
    commit(mutationTypes.TOGGLE_PAYIN_ACTION, payin);
  },
  setTicketRules({ commit }, rules) {
    commit(mutationTypes.SET_TICKET_RULES, rules);
  },
  setBalanceValue({ commit }, value) {
    commit(mutationTypes.SET_BALANCE_VALUE, value);
  },
  goToDetailBet({ commit }, bet) {
    commit(mutationTypes.GO_TO_DETAIL_BET, bet);
  },
  resetSelectedBet({ commit }) {
    commit(mutationTypes.RESET_SELECTED_BET);
  },

  addBetItem({ commit }, item) {
    commit(mutationTypes.ADD_BET_ITEM, item);
  },
  removeBetItem({ commit }, item) {
    commit(mutationTypes.REMOVE_BET_ITEM, item);
  },
  removeAllItems({ commit }) {
    commit(mutationTypes.REMOVE_ALL_ITEMS);
  },
  currentBetItem({ commit }) {
    commit(mutationTypes.GET_CURRENT_BET_ITEM);
  },
  checkBalance({ commit, getters, dispatch }) {
    const balance = getters.player.balance.balanceAmt;
    const { totalPayment } = getters;
    if (getters.player.loggedIn) {
      commit(mutationTypes.CHECK_BALANCE);
      if (balance < totalPayment) {
        dispatch('updateNotifications', {
          status: 'error',
          message: getters.translations.general_ticket_balance_warning,
        });
      }
    }
  },
};
